var ModuleDuck = /** @class */ (function () {
    function ModuleDuck(module, app) {
        var _this = this;
        this.defineType = function (type) {
            return _this.appName
                ? _this.appName + "/" + _this.moduleName + "/" + type
                : _this.moduleName + "/" + type;
        };
        this.createAction = function (type) { return function (payload) {
            var action = {
                type: type,
                payload: payload
            };
            return action;
        }; };
        this.createReducer = function (cases, initialState) {
            if (initialState === void 0) { initialState = {}; }
            return function (state, action) {
                if (state === undefined)
                    return initialState;
                if (action !== undefined) {
                    for (var caseName in cases) {
                        if (action.type === caseName)
                            return cases[caseName](state, action);
                    }
                }
                return state;
            };
        };
        this.moduleName = module;
        this.appName = app;
    }
    return ModuleDuck;
}());

export default ModuleDuck;
